import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const TechnologicalDistinction = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>Technological Distinction</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="technological-distinction.png"
              alt="Technological Distinction"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="technological-distinction-mobile.png"
                alt="Technological Distinction"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologicalDistinction;
